import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-custom-snackbar',
  standalone: true,
  imports: [MatIconModule, MatButtonModule],
  templateUrl: './custom-snackbar.component.html',
  styleUrl: './custom-snackbar.component.scss',
})
export class CustomSnackbarComponent {
  sanitizedMessage: SafeHtml;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: {
      icon: string;
      title: string;
      message: string;
    },
    private sanitizer: DomSanitizer,
    private snackBarRef: MatSnackBarRef<CustomSnackbarComponent>,
  ) {
    this.sanitizedMessage = this.sanitizer.bypassSecurityTrustHtml(
      data.message,
    );
  }

  close(): void {
    this.snackBarRef.dismiss();
  }
}
